import { Tooltip, Zoom, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        TransitionComponent={Zoom}
        placement="top"
        {...props}
        arrow
        classes={{ popper: className }}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: 11,
        padding: '6px 10px', // Reduced padding (default is usually 8px 16px)
        maxWidth: 200, // Limit maximum width
        // You can reduce further if needed
    },
}));

export default CustomTooltip;
